import { useState } from 'react'

import { AddButton } from '#app/routes/mocra+/_form+/components/add-button.tsx'

import { MonitoringFeedOverlay } from '#app/routes/mocra+/_form+/components/monitoring-feeds/overlay.tsx'
import {
	createMonitoringFeedDraft,
	type MonitoringFeedDraft,
} from '#app/routes/mocra+/_form+/components/monitoring-feeds/types.ts'

type Props = {
	readonly onSubmit: (draft: MonitoringFeedDraft) => void
	readonly defaultValue?: MonitoringFeedDraft
	readonly triggerLabel?: string
	readonly disabled?: boolean
	readonly className?: string
}

export function MonitoringFeedAdd({
	onSubmit,
	defaultValue,
	triggerLabel,
	disabled,
	className,
}: Props) {
	const [open, setOpen] = useState(false)

	const handleSubmit = (draft: MonitoringFeedDraft) => {
		onSubmit(draft)
		setOpen(false)
	}

	return (
		<>
			<AddButton
				onClick={() => setOpen(true)}
				disabled={disabled}
				className={className}
			>
				{triggerLabel ?? 'Add feed'}
			</AddButton>
			<MonitoringFeedOverlay
				mode="add"
				open={open}
				onOpenChange={setOpen}
				onSubmit={handleSubmit}
				initialValue={defaultValue ?? createMonitoringFeedDraft()}
				onClosed={() => setOpen(false)}
			/>
		</>
	)
}
